<script>
    import PageHeader from '$lib/components/PageHeader.svelte';

    export let content = {};
    export let modulePosition;
    export let sectionPosition;

    const padding = content?.settings?.padding ? 'px-2 py-8 lg:px-0' : '';
</script>

<PageHeader
    title={content?.title}
    description={content?.description}
    backButton={content?.settings?.backButton}
    shareButton={content?.settings?.shareButton}
    userButton={content?.settings?.userButton}
    searchButton={content?.settings?.searchButton}
    homeButton={content?.settings?.homeButton}
    classes={padding}
/>
